var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    staticClass: "w-100 px-16 px-lg-20 justify-space-between",
    class: {
      'grey-c4': _vm.isClosed || _vm.isApproved,
      'primary--light': !_vm.isClosed && !_vm.isApproved
    },
    attrs: {
      "disabled": "",
      "x-large": "",
      "rounded": "",
      "elevation": "0"
    }
  }, [_c('span', {
    staticClass: "grey-dark--text"
  }, [_vm._v(_vm._s(_vm.time) + "시(" + _vm._s(_vm.isClosed || _vm.isApproved ? "마감" : "승인대기") + ")")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }